import { useNavigate } from 'react-router-dom'

export function ErrorPage() {
    const navigate = useNavigate()

    return <div className='error'>
        <span className="material-symbols-outlined">error</span>
        <h1>העמוד אינו זמין כעת.</h1>
        <p>אנא נסה שנית מאוחר יותר.</p>
        <p className='clickable underline main7' onClick={() => navigate('/')}>חזרה לעמוד הבית</p>
    </div>
}